/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogInputInteger } from "../../d-dialog-input-integer";
import { DThemeDarkDialogInput } from "./d-theme-dark-dialog-input";

export class DThemeDarkDialogInputInteger
	extends DThemeDarkDialogInput
	implements DThemeDialogInputInteger {}
